// Hover Swatches para Productos Hermanos
if (!window.siblingSwatchesHoverInitialized) {
  window.siblingSwatchesHoverInitialized = true;
  document.addEventListener('mouseover', function(e) {
    const swatchLink = e.target.closest('[data-sibling-swatch-image]');
    if (!swatchLink) return;

    const card = swatchLink.closest('product-grid-item');
    if (!card) return;

    const variantId = swatchLink.getAttribute('data-sibling-variant');
    if (!variantId) return;

    const targetVariant = card.querySelector(`product-grid-item-variant[data-grid-item-variant="${variantId}"]`);
    if (targetVariant) {
      card.querySelectorAll('product-grid-item-variant').forEach(el => {
        el.setAttribute('hidden', '');
      });
      targetVariant.removeAttribute('hidden');
    }

    card.querySelectorAll('.siblings__link').forEach(link => {
      link.classList.remove('siblings__link--current');
    });
    swatchLink.classList.add('siblings__link--current');
  });

  document.addEventListener('mouseout', function(e) {
    const swatchLink = e.target.closest('[data-sibling-swatch-image]');
    if (!swatchLink) return;

    const card = swatchLink.closest('product-grid-item');
    if (!card) return;

    const originalCurrent = card.querySelector('[data-is-original-current="true"]');
    if (originalCurrent) {
      const origVariantId = originalCurrent.getAttribute('data-sibling-variant');
      const origVariantEl = card.querySelector(`product-grid-item-variant[data-grid-item-variant="${origVariantId}"]`);
      if (origVariantEl) {
        card.querySelectorAll('product-grid-item-variant').forEach(el => {
          el.setAttribute('hidden', '');
        });
        origVariantEl.removeAttribute('hidden');
      }
    }

    card.querySelectorAll('.siblings__link').forEach(link => {
      link.classList.remove('siblings__link--current');
    });
    if (originalCurrent) {
      originalCurrent.classList.add('siblings__link--current');
    }
  });
}

// Cambio automático a la 2ª foto al hacer hover en Desktop
if (!window.hoverSliderDesktopInitialized) {
  window.hoverSliderDesktopInitialized = true;
  document.addEventListener('mouseover', function(e) {
    const wrapper = e.target.closest('.hs-wrapper');
    if (wrapper) {
      const slides1 = wrapper.querySelectorAll('.hs-slide[data-index="1"]');
      if (slides1.length > 1) {
        slides1[1].remove();
      }
    }
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const container = e.target.closest('.product-grid-item__images, .product-grid-item__container');
    if (!container) return;
    const scrollWrapper = container.querySelector('.hs-slides-wrapper');
    if (scrollWrapper && scrollWrapper.children.length > 1) {
      const slideWidth = scrollWrapper.clientWidth;
      if (slideWidth > 0 && scrollWrapper.scrollLeft < 10) {
        scrollWrapper.scrollTo({ left: slideWidth, behavior: 'auto' });
      }
    }
  });
  document.addEventListener('mouseout', function(e) {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const container = e.target.closest('.product-grid-item__images, .product-grid-item__container');
    if (!container) return;
    const related = e.relatedTarget;
    if (related && container.contains(related)) return;
    const scrollWrapper = container.querySelector('.hs-slides-wrapper');
    if (scrollWrapper) {
      const slideWidth = scrollWrapper.clientWidth;
      if (slideWidth > 0 && scrollWrapper.scrollLeft >= slideWidth - 10) {
        scrollWrapper.scrollTo({ left: 0, behavior: 'auto' });
      }
    }
  });
}

// Motor AJAX para Cargar Más (Load More dinámico)
if (!window.loadMoreInitialized) {
  window.loadMoreInitialized = true;
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#load-more-btn');
    if (!btn) return;
    e.preventDefault();
    var nextLink = document.querySelector('#CollectionPagination a.pagination__next') || document.querySelector('a.pagination__next');
    if (!nextLink || !nextLink.href) return;
    var textLoad = btn.getAttribute('data-text-load') || 'Cargar más productos';
    var textLoading = btn.getAttribute('data-text-loading') || 'Cargando...';
    var textSpan = btn.querySelector('.load-more-text');
    var spinner = btn.querySelector('.loading-overlay__spinner');
    if (textSpan) textSpan.innerText = textLoading;
    if (spinner) spinner.style.display = 'inline-block';
    btn.disabled = true;
    fetch(nextLink.href)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('.js-grid > div');
        var newPagination = doc.querySelector('#CollectionPagination');
        var grid = document.querySelector('.js-grid');
        if (grid && newItems.length) {
          newItems.forEach(function(item) {
            grid.appendChild(item);
          });
        }
        var currentPagination = document.querySelector('#CollectionPagination');
        if (currentPagination && newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
        } else if (currentPagination && !newPagination) {
          currentPagination.remove();
        }
        if (window.AOS) window.AOS.refresh();
      })
      .catch(function(err) {
        console.error('Error cargando más productos:', err);
        if (textSpan) textSpan.innerText = textLoad;
        if (spinner) spinner.style.display = 'none';
        btn.disabled = false;
      });
  });
}